import React from "react";
import { cleanName } from "../utils/parser";
import "./Stats.css";

interface IStatsProps {
  value: number;
  label: string;
  max?: number;
}

export default function Stats(props: IStatsProps) {
  const { value, label, max = 100 } = props;
  return (
    <div className="stats">
      <label htmlFor="label">{cleanName(label)}</label>
      <div className="progress-bar">
        <span>{`${Math.max(value, 0)}/${max}`}</span>
        <progress id="file" value={value} max={max}></progress>
      </div>
    </div>
  );
}
